import React from 'react';
import { Box } from '@mui/material';
import SidebarMenu from './SidebarMenu';
import AuthModal from './AuthModal';
// Стор задач генерации: импорт нужен ради самого подъёма стора — он возобновляет опрос после
// перезагрузки и держит его живым между переходами. AppShell монтируется один раз, поэтому
// место правильное. Сам модуль ленивый и SSR-безопасный, здесь ничего вызывать не надо.
import '../utils/jobs';
// Финализатор Ретуши (склейка с оригиналом) обязан быть зарегистрирован там же, где живёт опрос:
// задача, запущенная в Ретуши, может завершиться на любой другой странице.
import './ai/retouchStitch';

// Постоянная «оболочка» приложения: боковое меню монтируется ОДИН раз и живёт
// между переходами (через wrapPageElement), а меняется только контент справа.
// Именно это убирает мигание/перезагрузку меню при переключении пунктов.
// ВАЖНО: тут НЕТ ThemeProvider — приложение исторически работает на дефолтной
// теме MUI, и добавление кастомной темы изменило бы вид всех страниц.
const AppShell = ({ children, location }) => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <SidebarMenu location={location} />
      <Box
        sx={{
          flexGrow: 1,
          // minWidth: 0 обязателен: это flex-элемент строчного контейнера, а у таких
          // min-width по умолчанию auto — то есть min-content содержимого. Любой длинный
          // горизонтальный ряд внутри инструмента (превью локаций, чипы, сетка истории)
          // раздвигал им <main>, а за ним и страницу: замерено 1220px при окне 1032.
          // Ноль отвязывает ширину контента от его min-content, и переполняющие ряды
          // скроллятся внутри себя, как и задумано.
          minWidth: 0,
          marginLeft: 'var(--sidebar-width, 248px)',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh'
        }}
      >
        <Box component="main" sx={{ flexGrow: 1, bgcolor: '#FAFAFA', minHeight: '100vh' }}>
          {children}
        </Box>
      </Box>
      {/* Глобальная модалка авторизации — открывается по событию openAuthModal */}
      <AuthModal />
    </Box>
  );
};

export default AppShell;
